exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link[data-v-11f37e0f]{font-size:20px;color:#0e0e0e}.nav-link.active[data-v-11f37e0f]{color:#5451de!important;font-weight:700}", ""]);

// exports
